import { RESELLER_CERTIFICATE_NOTIFICATIONS_240611 } from "@faire/web-api/indigofair/settings/RESELLER_CERTIFICATE_NOTIFICATIONS_240611";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingResellerCertificateNotifications = (): boolean =>
  getSettingValueAndAssign(RESELLER_CERTIFICATE_NOTIFICATIONS_240611, false);
